<template>
	<Row class="flex-centerize py-3 width-100 close-extension-drawer-footer-container">
		<AnemicButton @click="closeBuilderDrawer" class="close-builder-button px-9" tile>
			Close builder <AppIcon name="close-builder-drawer" class="ml-3" />
		</AnemicButton>
	</Row>
</template>
<script>
export default {
	name: 'CloseBuilderDrawerFooter',
	methods: {
		closeBuilderDrawer() {
			this.$emit('close-builder');
		},
	},
};
</script>
<style scoped lang="scss">
.close-extension-drawer-footer-container {
	border-top: 1px solid #e7e7ed;
}
.close-builder-button {
	height: 45px !important;
	font-size: 14px !important;
	color: #5858ec !important;
	border-radius: 10px !important;
	letter-spacing: 0px !important;
	font-weight: normal !important;
	text-transform: none !important;
	background: var(--white) !important;
	border: 1px solid #5858ec !important;
}
</style>
